($ => {
  $.fn.radioControl = function () {
    var $radios= $(this).find('input[type=radio]');
    $radios.on('click',function () {
      $('[id^=radio-control-elem-] :input').attr("disabled", true);
      $('#radio-control-elem-' +  $(this).data('target') +' :input:not(.not-disable)').attr("disabled", false);
    });
  };
})(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/radio_control.js